"use strict";

module.exports = function (value) {
	// eslint-disable-next-line no-self-compare
	return value !== value;
};



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es5-ext/number/is-nan/shim.js
// module id = ../../../node_modules/es5-ext/number/is-nan/shim.js
// module chunks = 1